import { ErrorMessage } from '@loadsmart/loadsmart-ui'

import { type SignUp } from '../domain/SignUp'
import { type SignUpError } from '../use-cases/carrierSignUp'

export type ValidationErrorProps = {
  signUpError?: SignUpError
  field: keyof SignUp
}

export function ValidationError({ signUpError, field }: ValidationErrorProps) {
  if (signUpError?.validationErrors?.[field]) {
    return <ErrorMessage>{signUpError.validationErrors[field]}</ErrorMessage>
  }

  return null
}
